import styles from './HashtagTargets.module.css';

type Props = {
    hashtag: string;
};

/** The hash is stripped from the value the endpoint takes, so the chip puts it back on screen. */
export const HashtagChip = ({ hashtag }: Props) => (
    <span>
        <span className={styles.hash}>#</span>
        {hashtag}
    </span>
);
